export const getHdppDisplayedPreloadEvent = () => {
  return {
    eventMode: 'preload',
    category: {
      primaryCategory: 'hdpp content'
    },
    eventInfo: {
      eventName: 'hdpp display'
    },
    item: [{
      productInfo: {
        displayedProtectionPlan: true
      }
    }]
  };
};
export const hasPathNameChanged = _ref => {
  var _routerChangeEvent$ou, _routerChangeEvent$ou2;
  let {
    location,
    routerChangeEvent
  } = _ref;
  const previousPathName = location === null || location === void 0 ? void 0 : location.pathname;
  const newPathName = routerChangeEvent === null || routerChangeEvent === void 0 ? void 0 : (_routerChangeEvent$ou = routerChangeEvent.output) === null || _routerChangeEvent$ou === void 0 ? void 0 : (_routerChangeEvent$ou2 = _routerChangeEvent$ou.location) === null || _routerChangeEvent$ou2 === void 0 ? void 0 : _routerChangeEvent$ou2.pathname;
  return previousPathName !== newPathName;
};
//# sourceMappingURL=util.pip.analytics.js.map